import React, { useState } from "react"
import { storyblokEditable } from "gatsby-source-storyblok";
import { Href } from "../utils/helper";
import { useStaticQuery, graphql } from "gatsby"
import { Lang, LangEnum } from "../utils/lang"
import { useLocation } from '@reach/router';

const LandingPullDown = ({ blok }) => {
  const location = useLocation()
  let pathname = location.pathname
  if (pathname.endsWith("/")) {
     pathname = pathname.slice(0, -1)
  }
  const [option1, setOption1] = useState(pathname)
  const [option2, setOption2] = useState("")

  const { enLandingConfig, jaLandingConfig } = useStaticQuery(graphql`
  query {
    enLandingConfig: allStoryblokEntry(
      filter: {field_component: {eq: "landingConfig"}, full_slug: {eq: "landing-config"}}
    ) {
      edges {
        node {
          name
          full_slug
          content
          field_component
        }
      }
    }
    
    jaLandingConfig: allStoryblokEntry(
      filter: {field_component: {eq: "landingConfig"}, full_slug: {eq: "ja/landing-config"}}
    ) {
      edges {
        node {
          name
          full_slug
          content
        }
      }
    }
  }`)
  const lang = Lang()
  const landingConfig = lang === LangEnum.JA ? jaLandingConfig : enLandingConfig
  
  landingConfig.edges.forEach((e) => {
    e.node.content = typeof e.node.content === 'string' ? JSON.parse(e.node.content) : e.node.content;
  })

  const menu = landingConfig.edges[0].node.content.menus.find(m => m.menuId === blok.menuId);
  if(!menu || menu.length === 0) {
    console.log("menu not found")
    return null
  }
  // console.log(menu)
  // console.log(blok)
  
  const option1Change = (link) => {
    if (link) {
      window.location.href = link
    }
    setOption1(link)
  }

  const option2Change = (link) => {
    if (link) {
      window.location.href = link
    }
    setOption2(link)
  }
  return (
    <div {...storyblokEditable(blok)} style={{ 
      paddingTop: `${blok.paddingTop}px`, paddingBottom: `${blok.paddingBottom}px`}} >
      <div className="container max-w-[750px] mx-auto px-5 py-10 flex flex-col md:flex-row justify-center items-center gap-10">
        <div className="flex flex-col" {...storyblokEditable(menu)}>
          <label className="text-xl font-bold font-serif p-3">{menu.selectLabel1}</label>
          <div className="p-3 rounded-lg border border-gray-800 flex">
            <select name="menu1" className="outline-none w-full" defaultValue={option1} onChange={e => option1Change(e.target.value)}>
              <option value=""></option>
              {
                menu.options1.map((opt, i) => (
                  <option key={i} value={Href(opt.link)}>{opt.text}</option>
                ))
              }
            </select>
          </div>
        </div>

        { menu.selectLabel2 &&
        <div className="flex flex-col" {...storyblokEditable(menu)}>
          <label className="text-xl font-bold font-serif p-3">{menu.selectLabel2}</label>
          <div className="p-3 rounded-lg border border-gray-800 flex">
            <select name="menu2" className="outline-none w-full" defaultValue={option2} onChange={e => option2Change(e.target.value)}>
              <option value=""></option>
              {
                menu.options2.map((opt, i) => (
                  <option key={i} value={Href(opt.link)}>{opt.text}</option>
                ))
              }
            </select>
          </div>
        </div>
        }

      </div>
    </div >
  )
}

export default LandingPullDown
